module.exports = __webpack_public_path__ + "static/media/metodista_centro_rio.3d4eaa1a.jpg";